import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import i18n from "i18next";
import { toast } from "sonner";

const onError = (error: unknown) => {
  const requestError = error as {
    config?: { suppressToast?: boolean };
    response?: { status?: number };
  };
  if (requestError?.config?.suppressToast) return;
  if (requestError?.response?.status === 409) {
    void queryClient.invalidateQueries();
    window.history.replaceState(null, "", "/");
    window.dispatchEvent(new PopStateEvent("popstate"));
    setTimeout(() => {
      toast.error(i18n.t("error.conflictTitle"), {
        description: i18n.t("error.conflictDescription"),
      });
    }, 0);
    return;
  }
  toast.error(i18n.t("error.title"), {
    description: i18n.t("error.description"),
  });
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    },
  },
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
});
